import React from 'react';
import { APP_CONFIG } from '../../../utils/constants';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="border-t border-slate-200 dark:border-slate-800 bg-white dark:bg-slate-900">
      <div className="container-custom py-4">
        <div className="flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-slate-400 dark:text-slate-500">
          <span>
            © {currentYear}{' '}
            <span className="font-semibold text-primary-500">{APP_CONFIG.NAME}</span>
            . Todos os direitos reservados.
          </span>

          <div className="flex items-center gap-5">
            <a href="/termos"      className="hover:text-primary-500 transition-colors">Termos</a>
            <a href="/privacidade" className="hover:text-primary-500 transition-colors">Privacidade</a>
            <a href="/suporte"     className="hover:text-primary-500 transition-colors">Suporte</a>
          </div>

          <span>v{APP_CONFIG.VERSION}</span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
